import { getScrollableParents } from '../helpers'

export default function autoUpdate(scrollParents: Set<HTMLElement | Window>, fn: () => void) {
    scrollParents.forEach((container) => {
        container.addEventListener('scroll', fn, { passive: true })
        container.addEventListener('resize', fn, { passive: true })
    })
    fn()
    return () => {
        scrollParents.forEach((container) => {
            container.removeEventListener('scroll', fn)
            container.removeEventListener('resize', fn)
        })
    }
}
